var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.9525,
    height: 23.9525,
    transform: "translate(0.945312 0.953125)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9453 4.95312H11.9453C10.8408 4.95312 9.94534 5.84856 9.94534 6.95312H13.9453C16.1545 6.95312 17.9453 8.74399 17.9453 10.9531V18.9531C17.9453 21.1623 16.1545 22.9531 13.9453 22.9531H6.94531C4.73617 22.9531 2.94531 21.1623 2.94531 18.9531V10.9531C2.94531 8.74399 4.73617 6.95312 6.94531 6.95312H7.94534C7.94534 4.74399 9.7362 2.95312 11.9453 2.95312H18.9453C21.1545 2.95312 22.9453 4.74399 22.9453 6.95312V14.9531C22.9453 17.1623 21.1545 18.9531 18.9453 18.9531H17.9453V16.9531H18.9453C20.0499 16.9531 20.9453 16.0577 20.9453 14.9531V6.95312C20.9453 5.84856 20.0499 4.95312 18.9453 4.95312ZM6.94531 8.95312H13.9453C15.0499 8.95312 15.9453 9.84856 15.9453 10.9531V18.9531C15.9453 20.0577 15.0499 20.9531 13.9453 20.9531H6.94531C5.84074 20.9531 4.94531 20.0577 4.94531 18.9531V10.9531C4.94531 9.84856 5.84074 8.95312 6.94531 8.95312Z",
    fill: "#303C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.9e423690722bca7976cf0738cb53ea2e.svg";
export { ForwardRef as ReactComponent };